import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Trip extends Model {
  resource() {
    return 'admin/trips'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get typeList() {
    return this.types.map(function(obj) {
      return obj['id']
    })
  }

  get accommodationList() {
    return this.accommodation_types.map(function(obj) {
      return obj['id']
    })
  }

  get originFormatAddress() {
    // eslint-disable-next-line
    return this.origin?.formatted_address
  }

  get originPlacesId() {
    // eslint-disable-next-line
    return this.origin?.google_places_id
  }

  get destinationFormatAddress() {
    // eslint-disable-next-line
    return this.destination?.formatted_address
  }

  get destinationPlacesId() {
    // eslint-disable-next-line
    return this.destination?.google_places_id
  }

  get itineraryIds() {
    return this.itinerary_activities.map(function(obj) {
      return obj['itinerary_activity_template_id']
    })
  }

  get pointOfInterestAddress() {
    return this.point_of_interests.map(function(obj) {
      return obj['places_address']
    })
  }

  get pointOfInterestIds() {
    return this.point_of_interests.map(function(obj) {
      return obj['google_places_id']
    })
  }
}
